import styled from 'styled-components'

import theme from 'theme_'
import { StyledIcon } from '../../styles'
import { Font14 } from 'components/Typography'
import { SubInfoBlock, SubInfoBody } from '../styles'

export const HomeUsersContainer = styled(SubInfoBlock)``

export const HomeUsersBody = styled(SubInfoBody)`
  justify-content: center;
`

export const HomeUsersNoAdmin = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: 8px;
`

export const HomeUsersWarningIcon = styled(StyledIcon)`
  margin-right: 12px;
`

export const HomeUsersAmountContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 100%;
  gap: ${theme.spacing.xs};
`

export const HomeUsersAmount = styled.div`
  background-color: ${theme.colors.lighterGrey};
  border-radius: 8px;
  flex-basis: 50%;
  padding: 16px;
`

export const HomeUsersAmountTitle = styled.div`
  ${Font14};
`

export const HomeUsersAmountCount = styled.div`
  font-size: 28px;
  font-weight: 600;
  line-height: 32px;
  margin-top: 8px;
  text-align: center;
`

export const InviteHomeUserFormContainer = styled.div`
  margin: 0 auto;
  max-width: 320px;
`
